var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import classNames from 'classnames';
import { compareAsc } from 'date-fns';
import Calendar from './Calendar/Calendar';
/**
 * @export
 * Calendar component so display range of dates
 *
 * @advanced
 */
const CalendarComponent = (props) => {
    let { dates, onSelectDate, className } = props, rest = __rest(props
    // get range by dates 
    , ["dates", "onSelectDate", "className"]);
    // get range by dates 
    let sorted = dates.sort(compareAsc);
    let start = sorted[0];
    let end = sorted[sorted.length - 1];
    let range = { start, end };
    return (_jsx("div", { className: classNames("uxp-calendar-component-expanded", className), children: _jsx(Calendar, Object.assign({ range: range, dates: dates, onSelect: (range) => { }, onClickDate: onSelectDate, dateRange: true }, rest)) }));
};
export default CalendarComponent;
